export enum ConfettiVariant {
  screen = 'screen',
  bottom = 'bottom',
  paid = 'paid',
}

export interface ConfettiState {
  confetties: { key: string; variant: ConfettiVariant }[];
}

export interface ConfettiStore extends ConfettiState {
  actions: {
    show: (variant?: ConfettiVariant) => void;
    remove: () => void;
    showPaid: () => void;
  };
}
